/** 初期値の種別 */
export enum InitialSettingKinds {
  /** 先頭 */
  First = 1,
  /** 末尾 */
  Last = 2,
  /** 作成日 */
  CreateDate = 3,
}
